/* ============================================================
   AURA11 — thema-mechaniek · LAB35
   Zelfde interactie als de statische demo, maar de winkelmand
   praat hier met Shopify's Cart AJAX API en de Section Rendering
   API. Er staat bewust geen prijslogica in dit bestand: de
   bedragen komen uit Liquid, zodat kortingen, valuta en markten
   kloppen zonder dat wij ze narekenen.
   ============================================================ */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  var cfg = { freeFrom: 0, routes: {}, strings: {} };
  try { cfg = JSON.parse($('#au-config').textContent); } catch (e) {}

  document.body.classList.add('js');

  /* ---------- toast ---------- */
  var toastEl = $('#toast'), toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }

  /* ---------- winkelmandlade ---------- */
  var drawer = $('#cart'), scrim = $('#scrim'), lastFocus = null;

  function openCart() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('is-on');
    document.body.classList.add('au-locked');
    var close = $('#cartClose');
    if (close) close.focus();
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.classList.remove('is-on');
    document.body.classList.remove('au-locked');
    if (lastFocus) lastFocus.focus();
  }

  /* ---------- winkelmand verversen ----------
     De regels en de totalen komen als HTML terug van Shopify zelf. Dat scheelt
     een prijsimplementatie in JavaScript, en dus een tweede plek waar de prijs
     fout kan staan. */
  function refresh() {
    return fetch(cfg.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-on', cart.item_count > 0);
          var btn = el.closest('[data-open-cart]');
          if (btn) btn.setAttribute('aria-label', cfg.strings.cartLabel
            ? cfg.strings.cartLabel.replace('{{ count }}', cart.item_count) : btn.getAttribute('aria-label'));
        });
        var sub = $('[data-cart-subtotal]');
        if (sub) sub.textContent = money(cart.total_price);
        paintShip(cart.total_price, cart.item_count);
        return fetch(cfg.routes.cart + '?section_id=cart-lines')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var lines = $('[data-cart-lines]');
            if (!lines) return cart;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('[data-cart-lines]');
            if (fresh) lines.innerHTML = fresh.innerHTML;
            return cart;
          })
          .catch(function () { return cart; });
      });
  }

  function money(cents) {
    var s = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + s;
  }

  function paintShip(total, count) {
    var wrap = $('#shipBar'), txt = $('#shipTxt'), fill = $('#shipFill');
    if (!wrap || !cfg.freeFrom) return;
    if (!count) { wrap.classList.remove('is-on'); return; }
    wrap.classList.add('is-on');
    var left = cfg.freeFrom - total;
    if (left <= 0) {
      txt.textContent = cfg.strings.shipFree;
      wrap.classList.add('is-free');
      fill.style.width = '100%';
    } else {
      txt.textContent = (cfg.strings.shipLeft || '').replace('{{ amount }}', money(left));
      wrap.classList.remove('is-free');
      fill.style.width = Math.max(2, Math.round(total / cfg.freeFrom * 100)) + '%';
    }
  }

  function addVariant(id, sellingPlan, name) {
    var body = { items: [{ id: Number(id), quantity: 1 }] };
    if (sellingPlan) body.items[0].selling_plan = Number(sellingPlan);
    return fetch(cfg.routes.add + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.d.description || cfg.strings.error); return; }
        var label = name || (res.d.items && res.d.items[0] ? res.d.items[0].product_title : '');
        toast((sellingPlan ? cfg.strings.addedSub : cfg.strings.added).replace('{{ product }}', label));
        return refresh().then(openCart);
      })
      .catch(function () { toast(cfg.strings.error); });
  }

  function changeLine(line, qty) {
    return fetch(cfg.routes.change + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(qty) })
    }).then(refresh).catch(function () { toast(cfg.strings.error); });
  }

  /* ---------- klikafhandeling ---------- */
  document.addEventListener('click', function (e) {
    var el;

    if ((el = e.target.closest('[data-open-cart]'))) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-close-cart]') || e.target === scrim) { closeCart(); return; }

    if ((el = e.target.closest('[data-add-variant]'))) {
      e.preventDefault();
      addVariant(el.getAttribute('data-add-variant'), el.getAttribute('data-selling-plan'), el.getAttribute('data-name'));
      return;
    }

    if ((el = e.target.closest('[data-qty]'))) {
      e.preventDefault();
      changeLine(el.getAttribute('data-qty'), el.getAttribute('data-to'));
      return;
    }

    if ((el = e.target.closest('.au-acc__q'))) {
      // de panelen staan op height:0; zonder een gezette hoogte klapt er niets open
      var item = el.closest('.au-acc__it');
      var panel = item ? item.querySelector('.au-acc__a') : null;
      var open = el.getAttribute('aria-expanded') !== 'true';
      el.setAttribute('aria-expanded', String(open));
      if (item) item.classList.toggle('is-open', open);
      if (panel) {
        var inner = panel.firstElementChild;
        panel.style.height = open ? ((inner ? inner.offsetHeight : panel.scrollHeight) + 'px') : '0px';
      }
      return;
    }

    if ((el = e.target.closest('.au-thumb'))) {
      var stage = $('#galStage');
      if (stage) { stage.src = el.getAttribute('data-src'); stage.removeAttribute('srcset'); }
      $$('.au-thumb').forEach(function (t) { t.classList.toggle('is-on', t === el); });
      return;
    }

    if ((el = e.target.closest('[data-soon]'))) { e.preventDefault(); toast(cfg.strings.soon); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && drawer.classList.contains('is-open')) closeCart();
    var m = $('#mobielMenu');
    if (m && m.classList.contains('is-open')) closeMenu();
  });

  /* ---------- productformulier ---------- */
  $$('[data-product-form]').forEach(function (wrap) {
    var form = wrap.querySelector('form');
    var variantInput = wrap.querySelector('[data-variant-input]');
    var planInput = wrap.querySelector('[data-selling-plan]');
    var freq = wrap.querySelector('[data-freq]');
    var label = wrap.querySelector('[data-buy-label]');

    function syncPlan() {
      var chosen = wrap.querySelector('input[name="selling_plan_choice"]:checked');
      var planId = chosen ? chosen.getAttribute('data-plan') : '';
      if (freq && planId) planId = freq.value;
      if (planInput) planInput.value = planId || '';
      // zonder selling plans is er geen gekozen plan en dus geen selector; een
      // lege selector laat querySelector gooien en dat blokkeerde de hele pagina
      var sel = chosen ? chosen.getAttribute('data-controls') : '';
      var wrapper = sel ? wrap.querySelector(sel) : null;
      $$('.au-freq', wrap).forEach(function (f) { f.classList.toggle('is-on', !!(planId && wrapper)); });
      $$('.au-plan', wrap).forEach(function (p) {
        p.classList.toggle('is-on', p.contains(chosen));
      });
      var card = chosen ? chosen.closest('.au-plan') : null;
      var priceEl = card ? card.querySelector('.au-plan__price') : null;
      if (label && priceEl) {
        var amount = (priceEl.textContent.trim().split(/\s/)[0] || '').trim();
        if (amount) label.textContent = label.textContent.split('€')[0].trim() + ' ' + amount;
      }
    }

    $$('input[name="selling_plan_choice"]', wrap).forEach(function (r) {
      r.addEventListener('change', syncPlan);
    });
    if (freq) freq.addEventListener('change', syncPlan);
    try { syncPlan(); } catch (e) { console.warn('koopblok', e); }

    $$('.au-step', wrap).forEach(function (btn) {
      btn.addEventListener('click', function () {
        $$('.au-step', wrap).forEach(function (b) {
          b.classList.toggle('is-on', b === btn);
          b.setAttribute('aria-checked', String(b === btn));
        });
        if (variantInput) variantInput.value = btn.getAttribute('data-variant');
        if (label) label.textContent = label.textContent.split('€')[0].trim() + ' ' + money(Number(btn.getAttribute('data-price')));
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addVariant(variantInput.value, planInput ? planInput.value : '', null);
      });
    }
  });

  /* ---------- navigatie ---------- */
  var burger = $('#burger'), menu = $('#mobielMenu'), nav = $('#nav');
  function closeMenu() {
    if (!menu) return;
    menu.classList.remove('is-open');
    if (burger) { burger.setAttribute('aria-expanded', 'false'); burger.classList.remove('is-on'); }
    document.body.classList.remove('au-locked');
  }
  if (burger && menu) {
    burger.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', String(open));
      burger.classList.toggle('is-on', open);
      document.body.classList.toggle('au-locked', open);
      var bar = nav ? nav.getBoundingClientRect().bottom : 120;
      menu.style.paddingTop = Math.max(96, bar + 24) + 'px';
    });
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a') && !e.target.closest('[data-soon]')) closeMenu();
    });
  }
  if (nav) {
    var onScroll = function () { nav.classList.toggle('is-stuck', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  window.addEventListener('resize', function () {
    $$('.au-acc__it.is-open .au-acc__a').forEach(function (panel) {
      var inner = panel.firstElementChild;
      if (inner) panel.style.height = inner.offsetHeight + 'px';
    });
  });

  /* ---------- sticky koopbalk ---------- */
  var sticky = $('#sticky'), anchor = $('#stickyAnchor');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      sticky.classList.toggle('is-on', !es[0].isIntersecting && es[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(anchor);
  }

  /* ---------- scroll reveal ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    // Wat bij het laden al in beeld staat krijgt is-in direct: een observer
    // meldt zich pas bij de eerstvolgende render, en in een verborgen tab of
    // bij prerender komt die niet. De pagina mag nooit leeg blijven.
    var vh = window.innerHeight || 800;
    $$('.au-rv').forEach(function (el, i) {
      el.style.transitionDelay = (i % 4) * 70 + 'ms';
      if (el.getBoundingClientRect().top < vh) { el.classList.add('is-in'); return; }
      io.observe(el);
    });
  } else {
    $$('.au-rv').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- de aura: scrollvoortgang ----------
     Zet --sp (0 → 1) op <html>; het aura-veld verschuift daarmee van goud
     bovenaan naar lila onderaan. Gequantiseerd op stappen van 0,02 en volledig
     uit onder prefers-reduced-motion. */
  if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion:reduce)').matches) {
    var root = document.documentElement, last = -1, ticking = false;
    var writeSp = function () {
      ticking = false;
      var max = root.scrollHeight - window.innerHeight;
      var p = max > 0 ? window.scrollY / max : 0;
      p = Math.round(Math.min(1, Math.max(0, p)) * 50) / 50;
      if (p !== last) { last = p; root.style.setProperty('--sp', p); }
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(writeSp); }
    }, { passive: true });
    window.addEventListener('resize', writeSp, { passive: true });
    writeSp();
  }

  /* ---------- in de theme-editor opnieuw binden ---------- */
  document.addEventListener('shopify:section:load', function () { location.reload(); });

  refresh();
})();
